import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";

import {LandingComponent} from "./landing.component";

const routes: Routes = [
  {
    path: "",
    component: LandingComponent,
    // children: [
    //   {
    //     path: 'invites',
    //     loadChildren: () => import('../../features/invites/invites.module').then(m => m.InvitesModule)
    //   }
    // ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LandingRouting {
}
